<div class="row">
  <div class="col">{{ 'motCles.minimum' | translate: { max: max} }} @if (required) {
    <span class="star">*</span>
  } :</div>
</div>

<div class="row">
  <div class="col">
    <table mat-table [dataSource]="motClesTable">
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef class="col-number"></th>
        <td mat-cell *matCellDef="let i = index">
          {{(i+1)}}
        </td>
      </ng-container>
      <ng-container matColumnDef="motCleFr">
        <th mat-header-cell *matHeaderCellDef class="col-mot"> {{ 'general.fr' | translate }} </th>
        <td mat-cell *matCellDef="let element; let i = index" >
          <span class="span-mot">{{getMotCleTrans(element, 'fr')}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="motCleEn">
        <th mat-header-cell *matHeaderCellDef class="col-mot"> {{ 'general.en' | translate }} </th>
        <td mat-cell *matCellDef="let element">
          <span class="span-mot">{{getMotCleTrans(element, 'en')}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef  class="col-number"> {{ 'general.actions' | translate }} </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-icon class="mat-icon" (click)="editMotCle(element)">edit</mat-icon>
          @if (element.translations) {
            <mat-icon class="mat-icon" (click)="removeMotCle(i)">delete</mat-icon>
          }
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="motCleColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: motCleColumns;"></tr>
    </table>
  </div>
</div>
